import * as React from "react";
import { Component } from "react";
import { stylesheet } from "typestyle";
import { layout } from "../layout.js";
import { classNames } from "../utils.js";
import { KeyButton } from "./KeyButton.js";
export const EmptyDigit = "\0";
export const CodeDigits = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"]
];
export const PhoneDigits = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["+", "0", " "]
];
export const CodeDigits0 = [
    ...CodeDigits,
    ["0"]
];
export class KeyPad extends Component {
    render() {
        const { digits = CodeDigits, disabled, primary, round, border = false, size = 2, onType, className } = this.props;
        return (React.createElement("div", { className: className, style: { fontSize: `${size}rem` } }, digits.map((rowDigits, index) => (React.createElement("div", { key: index, className: classNames(layout.horizontal, round && styles.rowRound) }, rowDigits.map(digit => React.createElement(KeyButton, { key: digit, value: digit, disabled: disabled, onType: onType, round: round, border: border, primary: primary })))))));
    }
}
const styles = stylesheet({
    rowRound: {
        margin: "0.5em 0",
        justifyContent: "center"
    },
});
//# sourceMappingURL=KeyPad.js.map